import createClient from 'openapi-fetch'
import type { components, paths } from './gen/reconciliation'
import { authFetch, call } from './http'

export type ReconSchemas = components['schemas']
export type Match = ReconSchemas['Match']
export type MatchStatus = ReconSchemas['MatchStatus']
export type MatchTransaction = ReconSchemas['MatchTransaction']
export type MatchPayable = ReconSchemas['MatchPayable']

const origin = typeof location !== 'undefined' ? location.origin : 'http://localhost'

export const reconciliation = createClient<paths>({ baseUrl: `${origin}/api/reconciliation`, fetch: authFetch })

export const listMatches = (status: MatchStatus, cursor?: string, limit = 50) =>
  call(reconciliation.GET('/matches', { params: { query: { status, ...(cursor ? { cursor } : {}), limit } } }))

export const createMatch = (transactionId: string, payableIds: string[]) =>
  call(reconciliation.POST('/matches', { body: { transaction_id: transactionId, payable_ids: payableIds } }))

export type SumCheck = {
  /** sum of the selected payables in the transaction currency (minor units) */
  sum: number
  /** what they must add up to: the outgoing payment as a positive amount */
  target: number
  /** target − sum: > 0 still missing, < 0 too much */
  diff: number
  currencyMismatch: boolean
  ok: boolean
}

/** Live check for a manual match: payables in the transaction's currency summing exactly to −amount. */
export function sumCheck(tx: MatchTransaction, selected: MatchPayable[]): SumCheck {
  const target = -tx.amount.amount_minor
  const currencyMismatch = selected.some((p) => p.total.currency !== tx.amount.currency)
  const sum = selected.reduce((s, p) => s + (p.total.currency === tx.amount.currency ? p.total.amount_minor : 0), 0)
  const diff = target - sum
  return { sum, target, diff, currencyMismatch, ok: selected.length > 0 && !currencyMismatch && target > 0 && diff === 0 }
}
